import React, { useState, useEffect, Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";

import { helperFunction } from "../../constant/helper";
import { userActions } from "../../redux/actions";

import Card from "../../component/card/Card";

import UserLeftDetail from "../userDetail/UserLeftDetail";
import UserCalendar from "../userDetail/UserCalendar";
import moment from "moment";
import { createdAsFunction } from "../../constant/helper/helper";
import isEmpty from "../../validation/isEmpty";
import Starter from "../../component/Starter";
import { CREATED_AS_STATUS } from "../../constant/constant";

const Profile = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [calendarEvents, setCalendarEvents] = useState([]);
  const [userDetailData, setUserDetailData] = useState(null);

  const { currentUser } = useSelector((state) => state.auth);

  const {
    userError,
    userDetail,
    userResponse,
    userCalendarData
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (userResponse) {
      helperFunction.toastHelper("success", userResponse);
    }
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
  }, [userResponse, userError]);

  useEffect(() => {
    const filterBy = "mongoId";
    dispatch(
      userActions.getUserDetail(currentUser.id, loginType, filterBy)
    );
  }, [currentUser?.id]);

  useEffect(() => {
    if (userDetail !== null) {
      setUserDetailData(userDetail);
    }
  }, [userDetail]);

  // return background color f0r calendar
  const returnBackgroundColor = (type) => {
    if (type === "AB" || type === "A.B") {
      return "#fa5c7c";
    } else if (type === "FD" || type === "P") {
      return "#0acf97";
    } else if (type === "IN" || type === "I.N") {
      return "#39afd1";
    } else if (
      type === "HD" ||
      type === "H.D" ||
      type === "W.O" ||
      type === "E.O" ||
      type === "EO"
    ) {
      return "#ffbc00";
    } else if (type === "OT" || type === "O.T") {
      return "#39afd1";
    }
  };

  useEffect(() => {
    if (!isEmpty(userCalendarData)) {
      const attendanceData = userCalendarData.attendances.map(
        (calendarData) => {
          if (isEmpty(calendarData.date)) {
            calendarData.date = calendarData.Date;
          }

          const date = new Date(calendarData.date)
            .toISOString()
            .substring(0, 10);
          const type =
            CREATED_AS_STATUS[createdAsFunction(calendarData)];
          const backgroundColor = returnBackgroundColor(
            !isEmpty(type) ? type : "AB"
          );
          return {
            title: !isEmpty(type) ? type : "AB",
            date,
            color: "#777777",
            backgroundColor: backgroundColor
          };
        }
      );
      setCalendarEvents(attendanceData);
    } else if (typeof userCalendarData === "undefined") {
      setCalendarEvents([]);
    } else {
      setCalendarEvents([]);
    }
  }, [userCalendarData]);

  // handel month change
  const handleMonthChange = (payload) => {
    const dateRange = {
      fromDate: moment(payload.start).format("yyyy-MM-DD"),
      toDate: moment(payload.end).format("yyyy-MM-DD")
    };
    dispatch(
      userActions.getUserCalendarData(
        currentUser.id,
        dateRange,
        loginType
      )
    );
  };

  // show user left detail
  const showUserLeftDetail = () => {
    if (
      typeof userDetailData !== "undefined" &&
      userDetailData !== null
    ) {
      return (
        <UserLeftDetail
          userDetailData={userDetailData}
          loginType={loginType}
        />
      );
    } else {
      return (
        <>
          <Card>
            <Skeleton height={100} />
          </Card>
          <Card>
            <Skeleton height={200} />
          </Card>
          <Card>
            <Skeleton height={50} />
          </Card>
        </>
      );
    }
  };

  return (
    <Starter
      topBarTitle="My Profile"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li className="breadcrumb-item active">My Profile</li>
        </Fragment>
      }
    >
      <div className="row">
        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5">
          {showUserLeftDetail()}
        </div>
        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7">
          <UserCalendar
            calendarEvents={calendarEvents}
            handleMonthChange={handleMonthChange}
          />
        </div>
      </div>
    </Starter>
  );
};

export default Profile;
